// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@yaak/components/assets/fonts/inter/Inter-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@yaak/components/assets/fonts/inter/Inter-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@yaak/components/assets/fonts/inter/Inter-Regular.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Inter Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: 'Inter Medium';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2');
  font-style: normal;
}
@font-face {
  font-family: 'Inter Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2');
  font-style: normal;
}
.style__display--O7r7A {
  font-feature-settings: 'cv01', 'cv09', 'case', 'ss04';
  font-size: 2.75rem;
  font-weight: 700;
  font-family: 'Inter Bold', sans-serif;
  line-height: 3.25rem;
}
.style__displayLarge--RqPWM {
  font-size: 3.5rem;
  line-height: 4rem;
}
.style__displaySmall--o1oq3 {
  font-size: 2.25rem;
  line-height: 2.75rem;
}
.style__headline--wwPQj {
  font-feature-settings: 'cv01', 'cv09', 'case', 'ss04';
  font-size: 1.75rem;
  font-weight: 700;
  font-family: 'Inter Bold', sans-serif;
  line-height: 2.25rem;
}
.style__headlineLarge--li_BO {
  font-size: 2rem;
  line-height: 2.5rem;
}
.style__headlineSmall--VJqoI {
  font-size: 1.5rem;
  line-height: 2rem;
}
.style__title--_eJVg {
  font-feature-settings: 'cv01', 'cv09', 'case', 'ss04';
  font-size: 1rem;
  font-weight: 700;
  font-family: 'Inter Bold', sans-serif;
  line-height: 1.5rem;
  letter-spacing: 0.0094rem;
}
.style__titleLarge--cEVtr {
  font-size: 1.25rem;
  line-height: 1.75rem;
  letter-spacing: 0;
}
.style__titleSmall--uPdN3 {
  font-size: 0.875rem;
  line-height: 1.25rem;
  letter-spacing: 0.0063rem;
}
.style__label--PdB8M {
  font-family: 'Inter Medium', sans-serif;
  font-feature-settings: 'cv01', 'cv09', 'case', 'ss04';
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: 0.0313rem;
  line-height: 1rem;
}
.style__labelLarge--Hav2j {
  font-size: 0.875rem;
  line-height: 1.25rem;
  letter-spacing: 0.0063rem;
}
.style__labelSmall--bs7gb {
  font-size: 0.625rem;
  line-height: 1rem;
  letter-spacing: 0.0313rem;
}
.style__body--wlHYf {
  font-family: 'Inter Regular', sans-serif;
  font-feature-settings: 'cv01', 'cv09', 'case', 'ss04';
  font-size: 0.875rem;
  font-weight: 500;
  letter-spacing: 0.0156rem;
  line-height: 1.25rem;
}
.style__bodyLarge--j0Kza {
  font-size: 1rem;
  line-height: 1.5rem;
  letter-spacing: 0.0313rem;
}
.style__bodySmall--jiidM {
  font-size: 0.75rem;
  line-height: 1rem;
  letter-spacing: 0.0025rem;
}
.style__link--dnL6c {
  font-family: 'Inter Regular', sans-serif;
  font-feature-settings: 'cv01', 'cv09', 'case', 'ss04';
  font-size: 0.875rem;
  font-weight: 500;
  letter-spacing: 0.0156rem;
  line-height: 1.25rem;
  text-decoration: underline;
  cursor: pointer;
}
.style__linkLarge--JE3rR {
  font-size: 1rem;
  line-height: 1.5rem;
  letter-spacing: 0.0313rem;
}
.style__linkSmall--Rn4yE {
  font-size: 0.75rem;
  line-height: 1rem;
  letter-spacing: 0.0025rem;
}
.style__bold--BKzuE {
  font-weight: 600;
}
.style__light--ClJu9 {
  font-weight: 400;
}
a, a:link, a:visited, a:focus, a:hover, a:active {
  color: #000;
  text-decoration: none;
}
.style__action--LTTRE:hover, .style__underscore--JbGDV {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./../components/src/Typography/style.less"],"names":[],"mappings":"AAGA;EACE,yBAAA;EACA,4DAAA;EAEA,gBAAA;EACA,kBAAA;AAHF;AAMA;EACE,2BAAA;EACA,4DAAA;EAEA,kBAAA;AALF;AAQA;EACE,4BAAA;EACA,4DAAA;EAEA,kBAAA;AAPF;AAUA;EAEI,qDAAA;EACA,kBAAA;EACA,gBAAA;EACA,qCAAA;EACA,oBAAA;AATJ;AAWI;EACE,iBAAA;EACA,iBAAA;AATN;AAYI;EACE,kBAAA;EACA,oBAAA;AAVN;AALA;EAoBI,qDAAA;EACA,kBAAA;EACA,gBAAA;EACA,qCAAA;EACA,oBAAA;AAZJ;AAcI;EACE,eAAA;EACA,mBAAA;AAZN;AAeI;EACE,iBAAA;EACA,iBAAA;AAbN;AApBA;EAsCI,qDAAA;EACA,eAAA;EACA,gBAAA;EACA,qCAAA;EACA,mBAAA;EACA,yBAAA;AAfJ;AAiBI;EACE,kBAAA;EACA,oBAAA;EACA,iBAAA;AAfN;AAkBI;EACE,mBAAA;EACA,oBAAA;EACA,yBAAA;AAhBN;AAtCA;EA2DI,uCAAA;EACA,qDAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;AAlBJ;AAoBI;EACE,mBAAA;EACA,oBAAA;EACA,yBAAA;AAlBN;AAqBI;EACE,mBAAA;EACA,iBAAA;EACA,yBAAA;AAnBN;AAxDA;EAgFI,wCAAA;EACA,qDAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,oBAAA;AArBJ;AAuBI;EACE,eAAA;EACA,mBAAA;EACA,yBAAA;AArBN;AAwBI;EACE,kBAAA;EACA,iBAAA;EACA,yBAAA;AAtBN;AA1EA;EAgFI,wCAAA;EACA,qDAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,oBAAA;EAiBA,0BAAA;EACA,eAAA;AAnBJ;AAGI;EACE,eAAA;EACA,mBAAA;EACA,yBAAA;AADN;AAII;EACE,kBAAA;EACA,iBAAA;EACA,yBAAA;AAFN;AA9FA;EA2GI,gBAAA;AAVJ;AAjGA;EA+GI,gBAAA;AAXJ;AApGA;EAwHI,WAAA;EACA,qBAAA;AAZJ;AA7GA;EA8HI,0BAAA;AAbJ","sourcesContent":["@import '@yaak/components/src/colors';\n@import '@yaak/components/src/spacing';\n\n@font-face {\n  font-family: 'Inter Bold';\n  src: url('~@yaak/components/assets/fonts/inter/Inter-Bold.woff2')\n    format('woff2');\n  font-weight: 700;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Inter Medium';\n  src: url('~@yaak/components/assets/fonts/inter/Inter-Medium.woff2')\n    format('woff2');\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Inter Regular';\n  src: url('~@yaak/components/assets/fonts/inter/Inter-Regular.woff2')\n    format('woff2');\n  font-style: normal;\n}\n\n:local {\n  .display {\n    font-feature-settings: 'cv01', 'cv09', 'case', 'ss04';\n    font-size: 2.75rem;\n    font-weight: 700;\n    font-family: 'Inter Bold', sans-serif;\n    line-height: 3.25rem;\n\n    &Large {\n      font-size: 3.5rem;\n      line-height: @spacing-400;\n    }\n\n    &Small {\n      font-size: 2.25rem;\n      line-height: 2.75rem;\n    }\n  }\n\n  .headline {\n    font-feature-settings: 'cv01', 'cv09', 'case', 'ss04';\n    font-size: 1.75rem;\n    font-weight: 700;\n    font-family: 'Inter Bold', sans-serif;\n    line-height: 2.25rem;\n\n    &Large {\n      font-size: @spacing-200;\n      line-height: @spacing-250;\n    }\n\n    &Small {\n      font-size: @spacing-150;\n      line-height: @spacing-200;\n    }\n  }\n\n  .title {\n    font-feature-settings: 'cv01', 'cv09', 'case', 'ss04';\n    font-size: @spacing-100;\n    font-weight: 700;\n    font-family: 'Inter Bold', sans-serif;\n    line-height: @spacing-150;\n    letter-spacing: 0.0094rem;\n\n    &Large {\n      font-size: 1.25rem;\n      line-height: 1.75rem;\n      letter-spacing: 0;\n    }\n\n    &Small {\n      font-size: 0.875rem;\n      line-height: 1.25rem;\n      letter-spacing: 0.0063rem;\n    }\n  }\n\n  .label {\n    font-family: 'Inter Medium', sans-serif;\n    font-feature-settings: 'cv01', 'cv09', 'case', 'ss04';\n    font-size: @spacing-75;\n    font-weight: 500;\n    letter-spacing: 0.0313rem;\n    line-height: @spacing-100;\n\n    &Large {\n      font-size: 0.875rem;\n      line-height: 1.25rem;\n      letter-spacing: 0.0063rem;\n    }\n\n    &Small {\n      font-size: 0.625rem;\n      line-height: @spacing-100;\n      letter-spacing: 0.0313rem;\n    }\n  }\n\n  .body {\n    font-family: 'Inter Regular', sans-serif;\n    font-feature-settings: 'cv01', 'cv09', 'case', 'ss04';\n    font-size: 0.875rem;\n    font-weight: 500;\n    letter-spacing: 0.0156rem;\n    line-height: 1.25rem;\n\n    &Large {\n      font-size: @spacing-100;\n      line-height: @spacing-150;\n      letter-spacing: 0.0313rem;\n    }\n\n    &Small {\n      font-size: @spacing-75;\n      line-height: @spacing-100;\n      letter-spacing: 0.0025rem;\n    }\n  }\n\n  .link {\n    .body;\n    text-decoration: underline;\n    cursor: pointer;\n  }\n\n  .bold {\n    font-weight: 600;\n  }\n\n  .light {\n    font-weight: 400;\n  }\n\n  a,\n  a:link,\n  a:visited,\n  a:focus,\n  a:hover,\n  a:active {\n    color: @color-black;\n    text-decoration: none;\n  }\n\n  .action:hover,\n  .underscore {\n    text-decoration: underline;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"display": `style__display--O7r7A`,
	"displayLarge": `style__displayLarge--RqPWM`,
	"displaySmall": `style__displaySmall--o1oq3`,
	"headline": `style__headline--wwPQj`,
	"headlineLarge": `style__headlineLarge--li_BO`,
	"headlineSmall": `style__headlineSmall--VJqoI`,
	"title": `style__title--_eJVg`,
	"titleLarge": `style__titleLarge--cEVtr`,
	"titleSmall": `style__titleSmall--uPdN3`,
	"label": `style__label--PdB8M`,
	"labelLarge": `style__labelLarge--Hav2j`,
	"labelSmall": `style__labelSmall--bs7gb`,
	"body": `style__body--wlHYf`,
	"bodyLarge": `style__bodyLarge--j0Kza`,
	"bodySmall": `style__bodySmall--jiidM`,
	"link": `style__link--dnL6c`,
	"linkLarge": `style__linkLarge--JE3rR`,
	"linkSmall": `style__linkSmall--Rn4yE`,
	"bold": `style__bold--BKzuE`,
	"light": `style__light--ClJu9`,
	"action": `style__action--LTTRE`,
	"underscore": `style__underscore--JbGDV`
};
export default ___CSS_LOADER_EXPORT___;
